<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<FormItem prop="trackName" :label="$tt('充电站:')" :label-width="100">
			<Select :placeholder="$tt('站点列表')" style="width: 200px;" v-model="formInline.StationId">
				<Option :value='0'>{{$tt('全部')}}</Option>
				<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
			</Select>
		</FormItem>
		<FormItem prop="trackName">
			<Input type="text" v-model="formInline.TitleName" :placeholder="$tt('客户名称')">
			<span slot="prepend">{{$tt('抬头名称')}}</span>
			</Input>
		</FormItem>
		<FormItem prop="trackName">
			<Input type="text" v-model="formInline.Email" :placeholder="$tt('接收邮箱')">
			<span slot="prepend">{{$tt('接收邮箱')}}</span>
			</Input>
		</FormItem>
		<FormItem prop="trackName">
			<Input type="text" v-model="formInline.PhoneNo" :placeholder="$tt('接收号码')">
			<span slot="prepend">{{$tt('接收号码')}}</span>
			</Input>
		</FormItem>
		<!-- <FormItem prop="trackName">
			<Input type="text" v-model="formInline.MailingReceiver" :placeholder="$tt('接收人')">
			<span slot="prepend">{{$tt('接收人')}}</span>
			</Input>
		</FormItem> -->
		<!-- <FormItem prop="trackName">
			<Input type="text" v-model="formInline.OrderNo" :placeholder="$tt('订单单号')">
			<span slot="prepend">{{$tt('订单单号')}}</span>
			</Input>
		</FormItem> -->
		<FormItem prop="trackName" :label="$tt('发票状态:')" :label-width="100">
			<Select :placeholder="$tt('发票状态')" style="width: 200px;" v-model="formInline.InvoiceStatus">
				<Option :value='-1'>{{$tt('全部')}}</Option>
				<Option :value="0">{{$tt('未开票')}}</Option>
				<Option :value="1">{{$tt('开票中')}}</Option>
				<Option :value="2">{{$tt('已开票')}}</Option>
				<Option :value="9">{{$tt('拒绝开票')}}</Option>
			</Select>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
			<!-- <Button style="margin-left: 10px;" type="primary" @click="$emit('BillInvoice')">{{$tt('开票')}}</Button> -->
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('exportFile')" v-if="hasWidgets('export')">{{$tt('导出文件')}}</Button>
		</FormItem>
		<!-- <div style="float: right;">
			<Button type="primary" @click="$emit('show','add')">{{$tt('新增商户')}}</Button>
		</div> -->
	</Form>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					StationId: 0,
					TitleName: '',
					Email: '',
					PhoneNo: '',
					MailingReceiver: '',
					OrderNo: '',
				},
			};
		},
		mounted() {
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
		},
	}
</script>

<style>
</style>
